import useIsMobile from "../../../common/hooks/useIsMobile";
import { theme } from "../../../theme";

const Header = () => {
    const isMobile = useIsMobile();

    return (
        <div className={`card bg-gradient-${theme.main} mb-4 mt-2 mt-lg-0 mx-3`}>
            <div className="card-body p-3">
                <div className="row">
                    <div className={`col-${isMobile ? '12 text-center' : 8} mb-0`}>
                        <div className="numbers ms-3">
                            <h5 className="text-white font-weight-bolder mb-0 mt-2" >NEARBY TRADESPERSONS</h5>
                        </div>
                    </div>
                    {!isMobile && (
                        <div className="col-4 text-end">
                            <img className="w-30 me-3" src="/assets/img/instafix-logo-white.webp" alt="instafix-logo" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Header;